import { useFormContext } from '@kanda-libs/ks-component-ts';
import { removeTrailingWhitespace } from '../../../../../../../../../../utils';

const ContainerComponent = ({ children, arrayName, index }) => {
  const { getValues, setValue } = useFormContext();

  const name = `${arrayName}.${index}.description`;

  const value = getValues(name);

  const onBlur = () =>
    setValue(name, removeTrailingWhitespace(getValues(name)));

  return children({
    value,
    onBlur,
  });
};

ContainerComponent.displayName = 'Description-container';

export default ContainerComponent;
